module.exports = __webpack_public_path__ + "img/microplastics-process-3.eb287753.png";